import * as turf from '@turf/turf';
import { CONUS_CENTER } from '../constants/coords';

const MAP_BOUNDS_PADDING = 0.2;

const INIT_ZOOM = 3;
const MAX_ZOOM = 10;

const ANIMATION_OPTIONS = { duration: 1000 };

/**
 * calls fitBounds on `mapRef` to ensure all `features` are visible
 */
const fitMapBounds = ({ mapRef, features, maxZoom = MAX_ZOOM }) => {
  if (!mapRef.current) return;
  if (features.length > 0) {
    const bounds = turf.bbox(turf.featureCollection(features));

    const {
      offsetWidth: width,
      offsetHeight: height,
    } = mapRef.current.getContainer();

    mapRef.current.fitBounds(bounds, {
      padding: {
        top: MAP_BOUNDS_PADDING * height,
        bottom: MAP_BOUNDS_PADDING * height,
        left: MAP_BOUNDS_PADDING * width,
        right: MAP_BOUNDS_PADDING * width,
      },
      maxZoom,
      ...ANIMATION_OPTIONS,
    });
  } else {
    // If no features, reset to initial center and zoom:
    mapRef.current.flyTo({
      center: CONUS_CENTER,
      zoom: INIT_ZOOM,
      ...ANIMATION_OPTIONS,
    });
  }
};

export default fitMapBounds;
